import { render } from "./Account.vue?vue&type=template&id=b00a24d4"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"
script.render = render

export default script